import React from "react"
import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"
import clsx from "clsx"
import Img from "./Img"
import ImgWithPartners from "./ImgWithPartners"
import * as styles from "./banner.module.scss"
import {
  handleClickBanner,
  handleClickStickyBtn,
} from "../../../helpers/WatcherDL/utils/handleClickBanner"

import { TypeBannerPropsWithElements } from "../helpers"
import { useObserver } from "../../../hooks/useObserver"

export function Banner({
  buttonText = "Оформить карту",
  orderNum,
  description,
  title,
  variant,
}: TypeBannerPropsWithElements) {
  const isVisible = useObserver(["formPkw", "calculator"])

  const renderImage = () => {
    switch (variant) {
      case "media":
        return <Img alt="bg image" className={styles.img} />

      default:
        return <ImgWithPartners alt="bg image" className={styles.img} />
    }
  }

  return (
    <>
      <section className={styles.section} data-exclude={orderNum}>
        <Container className={styles.container}>
          <div className={styles.secondContainer}>
            {renderImage()}
            <div className={styles.text}>
              <h1>{title}</h1>
              <div>{description}</div>
            </div>
            <Button className={styles.btn} onClick={() => handleClickBanner(buttonText, title)}>
              {buttonText}
            </Button>
          </div>
        </Container>
      </section>
      <div className={clsx(styles.btnBlock, { [styles.hideMobBlock]: isVisible })}>
        <Container>
          <Button onClick={handleClickStickyBtn} className={styles.mobBtn}>
            {buttonText}
          </Button>
        </Container>
      </div>
    </>
  )
}
